import imageProperties from '../lib/image-properties'

const createQuery = () => `
  ... on VideoGridWidget {
    title
    viewAllCtaLink
    dedupe
    limit
    suffix
    slotName
    background
    articles {
      results {
        _id
        headline
        eventId
        eventBaseSlug
        eventArticleCategoryKey
        fullUrlPath
        sell
        featured
        category
        tags {
          tag
        }
        images {
          thumbnail_widescreen_644 {
            ${imageProperties}
          }
        }
      }
    }
    keyValueTargeting {
      key
      value
    }
  }
`

export default createQuery
